
export const initialUserState = { 
    idStr:      '', 
    expiryDate: '2023-09-01',
    grades:     '1234567', 
    plus:       0,
    semelMosad: '',
    comments:   '' 
};

export const initialApprovedUserState = { 
    emailStr: '', 
    org_name: '',
};




export const initialSchoolState = { 
    idStr:    '', 
    grades:   '1234567', 
    plus:     0, 
    comments: '' 
};

export const initialExtensionState = { 
    userEmail: '',
    date:      '2023-10-01'
};

export const initialChangePlusState = { 
    table:     '',
    userEmail: '',
    action:    '',
    ind:       -1
};


export const initialSumToPayState = { 
    table:     '',
    userEmail: '',
    sumToPay:  '',
    ind:       -1
};


export const initialCommentState = { 
    table:     '',
    userEmail: '',
    comment:   '',
    ind:       -1
};

export const initialExpiryDateState = { 
    table:     '',
    userEmail: '',
    expiryDate:'2023-10-01',
    ind:       -1
};

export const initialGradesState = { 
    table:     '',
    userEmail: '',
    grades:    '1234567',
    ind:       -1
};


export const initialEditMessageState = { 
    showForm:  false,
    messageId: -1,
    comment:   ''
};

export const initialModalState = { 
    showModal:    false,
    modalVariant: '',
    modalValue:   '',
};

